<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Nouveau client</h2>
    <p class="page-subtitle">Remplissez les informations pour enregistrer un nouveau client</p>
  </div>
  <a routerLink="/clients" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </a>
</div>

<div class="form-container">
  <div class="card shadow-sm">
    <form [formGroup]="clientForm" (ngSubmit)="onSubmit()" class="modern-form">
      <div class="form-section">
        <h3 class="section-title">Informations administratives</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="numeroClient">NUMÉRO CLIENT</label>
            <input type="text" id="numeroClient" formControlName="numeroClient" class="form-control" placeholder="ex: CL-2024-001">
            @if (clientForm.get('numeroClient')?.touched && clientForm.get('numeroClient')?.invalid) {
              <div class="field-error">
                @if (clientForm.get('numeroClient')?.errors?.['required']) {
                  <span>Le numéro client est requis.</span>
                }
                @if (clientForm.get('numeroClient')?.errors?.['numeroClient']) {
                  <span>Format invalide (lettres/chiffres, '-' et '/' autorisés, 3 à 30 caractères).</span>
                }
              </div>
            }
          </div>
          <div class="form-group col">
            <label for="siret">SIRET</label>
            <input type="text" id="siret" formControlName="siret" class="form-control" placeholder="14 chiffres">
            @if (clientForm.get('siret')?.touched && clientForm.get('siret')?.errors?.['siret']) {
              <div class="field-error">Le SIRET doit contenir exactement 14 chiffres.</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="denomination">DÉNOMINATION / NOM</label>
            <input type="text" id="denomination" formControlName="denomination" class="form-control" placeholder="Nom de l'entreprise">
            @if (clientForm.get('denomination')?.touched && clientForm.get('denomination')?.errors?.['required']) {
              <div class="field-error">La dénomination est requise.</div>
            }
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Adresse et Localisation</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="adresseFacturation">ADRESSE DE FACTURATION</label>
            <input type="text" id="adresseFacturation" formControlName="adresseFacturation" class="form-control">
            @if (clientForm.get('adresseFacturation')?.touched && clientForm.get('adresseFacturation')?.errors?.['required']) {
              <div class="field-error">L'adresse de facturation est requise.</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="ville">VILLE</label>
            <input type="text" id="ville" formControlName="ville" class="form-control">
            @if (clientForm.get('ville')?.touched && clientForm.get('ville')?.errors?.['required']) {
              <div class="field-error">La ville est requise.</div>
            }
          </div>
          <div class="form-group col">
            <label for="codePostal">CODE POSTAL</label>
            <input type="text" id="codePostal" formControlName="codePostal" class="form-control">
            @if (clientForm.get('codePostal')?.touched && clientForm.get('codePostal')?.invalid) {
              <div class="field-error">
                @if (clientForm.get('codePostal')?.errors?.['required']) {
                  <span>Le code postal est requis.</span>
                }
                @if (clientForm.get('codePostal')?.errors?.['codePostal']) {
                  <span>Le code postal doit contenir 5 chiffres.</span>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Photo du client</h3>
        <div class="form-group">
          <div class="drop-zone"
               [class.drag-over]="isDragOver()"
               (dragover)="onDragOver($event)"
               (dragleave)="onDragLeave($event)"
               (drop)="onDrop($event)"
               (click)="fileInput.click()">
            @if (!previewDataUrl()) {
              <div class="drop-zone__content">
                <mat-icon class="drop-zone__icon" aria-hidden="true">photo_camera</mat-icon>
                <div class="drop-zone__text">
                  Glissez-déposez une photo ici ou cliquez pour sélectionner un fichier
                </div>
                <div class="drop-zone__hint">PNG, JPG jusqu'à ~5 Mo</div>
              </div>
            } @else {
              <div class="preview">
                <img [src]="previewDataUrl()" alt="Prévisualisation" />
                <button type="button" class="btn btn-outline" (click)="removeSelectedFile(); $event.stopPropagation();">Retirer</button>
              </div>
            }
          </div>
          <input #fileInput type="file" (change)="onFileSelected($event)" accept="image/*" class="hidden-input">
          <p class="help-text">Vous pourrez modifier la photo ensuite si nécessaire.</p>
        </div>
      </div>

      @if (errorMessage()) {
        <div class="error-banner">{{ errorMessage() }}</div>
      }

      <div class="form-actions">
        <button type="button" routerLink="/clients" class="btn btn-outline">Annuler</button>
        <button type="submit" [disabled]="clientForm.invalid || isLoading()" class="btn btn-primary">
          {{ isLoading() ? 'Création en cours...' : 'Créer le client' }}
        </button>
      </div>
    </form>
  </div>
</div>

<style>
.field-error {
  color: #c62828;
  font-size: 12px;
  margin-top: 4px;
}
/* Rendre visuellement les boutons disabled bien grisés et inactifs */
.btn[disabled] {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
